import { defineComponent as _defineComponent } from 'vue';
import { ref, onMounted, onUnmounted } from "vue";
import ActivityItem from "components/ActivityBar/ActivityItem.vue";
// @ts-ignore
import Query from "utils/query-string-parsing.js";
// @ts-ignore
import { useGlobalUploadModal } from "composables/globalUploadModal.js";
// @ts-ignore
import { eventHub } from "components/plugins/eventHub.js";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UploadItem',
    props: {
        id: null,
        title: null,
        icon: null,
        tooltip: null
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const { openGlobalUploadModal } = useGlobalUploadModal();
        const status = ref("success");
        const percentage = ref(0);
        onMounted(() => {
            eventHub.$on("upload:status", setStatus);
            eventHub.$on("upload:percentage", setPercentage);
            if (Query.get("tool_id") == "upload1") {
                openGlobalUploadModal();
            }
        });
        onUnmounted(() => {
            eventHub.$off("upload:status", setStatus);
            eventHub.$off("upload:percentage", setPercentage);
        });
        function onUploadModal() {
            emit("click");
            openGlobalUploadModal();
        }
        function setStatus(val) {
            status.value = val;
        }
        function setPercentage(val) {
            percentage.value = val;
        }
        return { __sfc: true, openGlobalUploadModal, emit, status, percentage, onUploadModal, setStatus, setPercentage, ActivityItem };
    }
});
